import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=70d24f4b&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=70d24f4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d24f4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d24f4b')) {
      api.createRecord('70d24f4b', component.options)
    } else {
      api.reload('70d24f4b', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=70d24f4b&scoped=true&", function () {
      api.rerender('70d24f4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iJ0FwAMOH3Ye/JS/comp/DateRangeExt.vue"
export default component.exports